class UnauthorisedException extends Error {
  constructor(message) {
    super(message);
    this.name = 'UnauthorisedException';
  }
}

export default UnauthorisedException;
